export default __webpack_public_path__ + "static/logo-1a1ee3bb6c0074d9747ab742e29415fb.png";